var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.985 3.184h2.022v7.01h4.963L11.99 16.2l-5.993-6.005h4.988zM4 12.132v7.028h16v-7.028h2v8.018a1.01 1.01 0 0 1-1.01 1.01H3.01A1.01 1.01 0 0 1 2 20.15v-8.018z",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;